// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-header[data-v-805d089e] { margin-bottom: 16px;\n}\n.page-title[data-v-805d089e] { font-size: 20px; font-weight: 500; margin-bottom: 4px;\n}\n.page-sub[data-v-805d089e] { font-size: 13px; color: #86909c;\n}\n.filter-card[data-v-805d089e] .el-card__body { padding: 12px 16px;\n}\n.el-table[data-v-805d089e] .el-table__row { cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
